__turbopack_context__.v({
  "card": "CardBlock-module-scss-module__4m7o8G__card",
});
